import { useQuery } from '@apollo/client';
import { useCallback } from 'react';
import { useCountry } from '../../components/CountrySelector';
import { GET_RETURNS_QUERY } from './returns.rest';

export const useReturns = () => {
  const { country } = useCountry();

  const {
    data,
    loading,
    error,
    fetchMore: fetchMoreFn
  } = useQuery(GET_RETURNS_QUERY, {
    variables: {
      countryCode: country.alpha2Code,
      pageNumber: 1
    },
    notifyOnNetworkStatusChange: true
  });

  const fetchMore = useCallback(
    (pageNumber: number) => {
      fetchMoreFn({
        variables: {
          pageNumber
        }
      });
    },
    [fetchMoreFn]
  );

  return {
    returns: data?.getReturns.data,
    returnOrderItems: data?.getReturns.included,
    pagination: data?.getReturns.meta.pagination,
    loading,
    error,
    fetchMore
  };
};
